module.exports = __webpack_public_path__ + "static/media/huli_416.d3d07af7.gif";